import { Controller } from "stimulus"

// Shows the soutenance center select only to free candidates applying for a professional BAC:
// school candidates inherit the center of their school.
export default class extends Controller {

  connect() {
    this.professionalIds = JSON.parse(this.data.get('professionalIds') || '[]');
    this.parentElt = document.querySelector(this.data.get('parent'));
    this.inscriptionTypeElt = document.querySelector(this.data.get('inscriptionType'));
    this.selectElt = this.element.querySelector('select');
    if (!this.parentElt) return;

    this.toggle = this.toggle.bind(this);
    this.parentElt.addEventListener("change", this.toggle);
    if (this.inscriptionTypeElt) this.inscriptionTypeElt.addEventListener("change", this.toggle);
    this.toggle();
  }

  disconnect() {
    if (this.parentElt) this.parentElt.removeEventListener("change", this.toggle);
    if (this.inscriptionTypeElt) this.inscriptionTypeElt.removeEventListener("change", this.toggle);
  }

  toggle() {
    if (this.isProfessional() && this.isFreeCandidate()) {
      this.element.classList.remove("is-hidden");
    } else {
      this.element.classList.add("is-hidden");
      if (this.selectElt) this.selectElt.value = '';
    }
  }

  isProfessional() {
    return this.professionalIds.includes(parseInt(this.parentElt.value, 10));
  }

  isFreeCandidate() {
    // The inscription type select is only rendered for secretaries and correctors.
    return !this.inscriptionTypeElt || this.inscriptionTypeElt.value === 'free_candidate';
  }
}
